import { useEffect, useRef, useState } from 'react';
import { eventBus } from '@/shared/EventBus';
import { Icon } from './Icon';

/**
 * Przycisk „DO BOJU!" w arenie World Bossa (tylko scena 'sanctum').
 *
 * Klik → emituje `sanctum:rally` → `AtlantisSanctumScene` odpala wizualny zryw
 * petów (iskry, błysk, kino). **Czysto efektowne** — NIE zmienia serwerowego HP
 * (serwer i tak clampuje tempo), to feel-good moment dla gracza, nie mechanika mocy.
 *
 * Cooldown lokalny (UI) + guard po stronie sceny. Ikona mieczy ma graficzny
 * fallback `ui_power`, więc awaria pojedynczego assetu nie wprowadza emoji do UI.
 */
export function RallyButton() {
  const [cooldownMs, setCooldownMs] = useState(0);
  const intervalRef = useRef<number | null>(null);

  // Cooldown startuje DOPIERO po potwierdzeniu przez scenę (`sanctum:rallyState`),
  // nie na klik — inaczej klik w złym stanie (cooldown bossa / brak petów) blokowałby
  // przycisk mimo że scena rally odrzuciła (LOW review).
  useEffect(() => {
    const off = eventBus.on('sanctum:rallyState', ({ cooldownMs: ms }) => {
      const start = Date.now();
      setCooldownMs(ms);
      if (intervalRef.current) window.clearInterval(intervalRef.current);
      intervalRef.current = window.setInterval(() => {
        const left = ms - (Date.now() - start);
        if (left <= 0) {
          setCooldownMs(0);
          if (intervalRef.current) {
            window.clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
        } else {
          setCooldownMs(left);
        }
      }, 100);
    });
    return () => {
      off();
      if (intervalRef.current) window.clearInterval(intervalRef.current);
    };
  }, []);

  const onClick = (): void => {
    if (cooldownMs > 0) return;
    eventBus.emit('sanctum:rally', {}); // cooldown ustawi `sanctum:rallyState`, gdy scena zaakceptuje
  };

  const onCooldown = cooldownMs > 0;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={onCooldown}
      className={`absolute bottom-6 left-1/2 -translate-x-1/2 z-40 pointer-events-auto rounded-2xl shadow-lg px-5 py-2.5 flex items-center gap-2 transition-all ${
        onCooldown
          ? 'bg-white/60 opacity-70 cursor-default'
          : 'bg-gradient-to-b from-orange-400 to-orange-600 hover:from-orange-300 hover:to-orange-500 active:scale-95'
      }`}
    >
      <Icon
        src="/ui/ui_rally_swords.webp"
        fallbackSrc="/ui/ui_power.webp"
        fallback=""
        alt="do boju"
        className="w-7 h-7"
      />
      <span className="text-sm sm:text-base font-extrabold text-white drop-shadow">
        {onCooldown ? `${Math.ceil(cooldownMs / 1000)}s` : 'DO BOJU!'}
      </span>
    </button>
  );
}
